import { useCallback } from 'react';
import { useSnackbar } from 'notistack';
import fileDownload from 'js-file-download';
import { replace } from 'lodash';

import { useLazyRequest } from '~hooks/index';
import { getEvidencesOrderPDFByTrackingCode } from '~services/order';

interface DownloadEvidencesOrderPDFReturn {
  loading: boolean;
  onDownloadPDF: () => Promise<void>;
}

export const useDownloadEvidencesOrderPDF = (
  trackingCode?: string,
): DownloadEvidencesOrderPDFReturn => {
  const { enqueueSnackbar } = useSnackbar();

  const [, loadingDownload, , executeDownload] = useLazyRequest({
    request: getEvidencesOrderPDFByTrackingCode,
    withPostSuccess: ({ data: dataExportResponse }) => {
      if (dataExportResponse) {
        const parseRouteCode = trackingCode
          ? replace(trackingCode, /-/g, '')
          : '';

        const fileName = `comprobante-visita-${parseRouteCode}.pdf`;

        fileDownload(dataExportResponse, fileName);

        enqueueSnackbar(
          `Se ha descargado el comprobante de visita correctamente`,
          { variant: 'success' },
        );
      }
    },
    withPostFailure: () => {
      enqueueSnackbar(
        'No se pudo descargar el comprobante de visita, intente nuevamente',
        { variant: 'error' },
      );
    },
  });

  const onDownloadPDF = useCallback(async () => {
    if (trackingCode) await executeDownload(trackingCode);
  }, [executeDownload, trackingCode]);

  return { loading: loadingDownload, onDownloadPDF };
};
